import React, { useCallback, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import iconX from 'assets/images/icons/iconX.svg';
import FilterMobileMenu from 'cards/components/CardListing/CardListingRedesign/CardListingFilter/FilterMobileMenu/FilterMobileMenu';
import { hideModal, openModal, updateModalOptions } from '../../actions/modalActions';

import DeletePhotoModal from './modals/DeletePhotoModal';
import CropModal from './modals/CropModal/CropModal';
import CloseCustomModal from './modals/CloseCustomModal';
import ErrorModal from './modals/ErrorModal/ErrorModal';
import RequestMissingInfoModalV2 from '../../../components/common/modals/RequestMissingInfoModal/RequestMissingInfoModal';
import PaperTypeModal from './modals/PaperTypeModal/PaperTypeModal';
import RejectSmallPhotoUploadModal from './modals/RejectSmallPhotoUploadModal';
import RejectBigPhotoUploadModal from './modals/RejectBigPhotoUploadModal';
import DeleteProjectDraftModal from './modals/DeleteProjectDraftModal/DeleteProjectDraftModal';
import ReviewAddressingModal from './modals/ReviewEnvelopeAddressingModal/ReviewAddressingModal';
import EtiquetteTips from './modals/TipsModals/TipsEtiquette';
import ExistingDraftsForCardSuiteModal from './modals/ExistingDraftsForCardSuiteModal/ExistingDraftsForCardSuiteModal';
import TipBack from './modals/TipsModals/TipBack';
import TipFront from './modals/TipsModals/TipFront';
import TipRSVP from './modals/TipsModals/TipRSVP';
import TipRSVPEnvelope from './modals/TipsModals/TipRSVPEnvelope';
import TipEnvelope from './modals/TipsModals/TipEnvelope';
import TipSTDFront from './modals/TipsModals/TipSTDFront';
import TipSTDBack from './modals/TipsModals/TipSTDBack';
import TipCTDFront from './modals/TipsModals/TipCTDFront';
import TipCTDBack from './modals/TipsModals/TipCTDBack';
import TipProgram from './modals/TipsModals/TipProgram';
import TipMenu from './modals/TipsModals/TipMenu';
import TipThankYouCard from './modals/TipsModals/TipThankYouCard';
import TipCardTextReview from './modals/TipsModals/TipCardTextReview';
import TipEnclosure from './modals/TipsModals/TipEnclosure';
import ProofOrderModal from './modals/ProofOrderModal/ProofOrderModal';
import DeleteNote from './modals/DeleteNoteModal';
import SelectGuestNote from './modals/SelectGuestNoteModal';
import ReviewPrintedMessages from './modals/ReviewPrintedMessages/ReviewPrintedMessages';
import LeaveGuestNote from './modals/LeaveGuestNoteModal';
import WeddingShopItemsModal from './modals/WeddingShopItemsModal/WeddingShopItemsModal';
import LetterpressLearnMore from './Letterpress/LetterpressLearnMore/LetterpressLearnMore';
import SamplesModal from './modals/SamplesModal';
import SingleSampleLimitScreenModal from './modals/SamplesModal/SingleSampleLimitScreenModal';
import MultiSamplesTutorialModal from './modals/MultiSamplesTutorialModal/MultiSamplesTutorialModal';
import ProjectCloneModal from './modals/ProjectCloneModal/ProjectCloneModal';
import SelectBlankNotes from './modals/SelectBlankNotesModal';
import FilterFoilModal from './modals/FilterFoilModal/FilterFoilModal';
import FilterLetterpressModal from './modals/FilterLetterpressModal/FilterLetterpressModal';
import ExpeditedShippingModal from './modals/ExpeditedShippingModal/ExpeditedShippingModal';
import BleedModal from './modals/BleedModal/BleedModal';
import SimpleSignUpModal from './modals/SimpleSignUpModal/SimpleSignUpModal';
import ProofInfoModal from './modals/ProofModals/ProofInfoModal';
import ProofIncreaseConfirmModal from './modals/ProofModals/ProofIncreaseConfirmModal';
import ProofDecreaseConfirmModal from './modals/ProofModals/ProofDecreaseConfirmModal';
import DiscardTyNotesModal from './modals/CustomizationFlowModals/DiscardTyNotesModal';
import { PlaceCardOnMobileModal } from './modals/PlaceCardOnMobileModal';
import * as PlaceCardGuestListModals from './modals/PlaceCardGuestListModals';
import DigitalTips from './modals/Digital/DigitalTips';
import HowItWorks from './modals/Digital/HowItWorks';
import DigitalMoreInfo from './modals/Digital/DigitalMoreInfo';
import CreateSuperlink from './modals/Digital/CreateSuperlink';
import CreateWeddingWebsite from './modals/Digital/CreateWeddingWebsite';
import PublishWeddingWebsite from './modals/Digital/PublishWeddingWebsite';
import MaxPublished from './modals/Digital/MaxPublished';
import DigitalSTDFreeSampleModal from './modals/DigitalSTDFreeSampleModal/DigitalSTDFreeSampleModal';
import FavoritesModal from './modals/FavoritesModal';
import DigitalDownloadImageModal from './modals/Digital/ShareStepModals';
import DigitalDeleteConfirmationModal from './modals/Digital/DigitalDeleteConfirmationModal';
import DigitalMoveToDraftsModal from './modals/Digital/DigitalMoveToDraftsModal';
import DigitalExpiryInfoModal from './modals/Digital/DigitalExpiryInfoModal';
import DigitalEmailTemplateCustomizationModal from './modals/Digital/DSTDEmailTemplate/DigitalEmailTemplateCustomizationModal';
import MatchingItemPreviewModal from './modals/MatchingItemPreviewModal';

import styles from './CardsModalRoot.module.less';

const MODALS = {
  CROP_MODAL: CropModal,
  DELETE_PHOTO: DeletePhotoModal,
  CLOSE_CUSTOM: CloseCustomModal,
  ERROR: ErrorModal,
  REQUEST_MISSING_INFO_V2: RequestMissingInfoModalV2,
  PAPER_TYPE: PaperTypeModal,
  REJECT_SMALL_PHOTO_MODAL: RejectSmallPhotoUploadModal,
  REJECT_BIG_PHOTO_MODAL: RejectBigPhotoUploadModal,
  DELETE_PROJECT_DRAFT: DeleteProjectDraftModal,
  EXISTING_DRAFTS_FOR_CARD_SUITE: ExistingDraftsForCardSuiteModal,
  TIPS_ETIQUETTE: EtiquetteTips,
  TIPS_INVITATION_BACK: TipBack,
  TIPS_INVITATION_FRONT: TipFront,
  TIPS_CHANGE_THE_DATE_FRONT: TipCTDFront,
  TIPS_CHANGE_THE_DATE_BACK: TipCTDBack,
  TIPS_RSVP: TipRSVP,
  TIPS_RSVP_ENVELOPE: TipRSVPEnvelope,
  TIPS_ENVELOPE: TipEnvelope,
  TIPS_SAVE_THE_DATE_FRONT: TipSTDFront,
  TIPS_SAVE_THE_DATE_BACK: TipSTDBack,
  REVIEW_ADDRESSING: ReviewAddressingModal,
  TIPS_PROGRAM_FRONT: TipProgram,
  TIPS_PROGRAM_BACK: TipProgram,
  TIPS_MENU_FRONT: TipMenu,
  TIPS_MENU_BACK: TipMenu,
  TIPS_THANK_YOU_FRONT: TipThankYouCard,
  TIPS_CARD_TEXT_REVIEW: TipCardTextReview,
  TIPS_THANK_YOU_BACK: TipThankYouCard,
  TIPS_ENCLOSURE_FRONT: TipEnclosure,
  TIPS_ENCLOSURE_BACK: TipEnclosure,
  TIPS_DIGITAL_SAVE_THE_DATE_FRONT: DigitalTips,
  PROOF_ORDER: ProofOrderModal,
  DELETE_NOTE: DeleteNote,
  SELECT_GUEST_NOTE: SelectGuestNote,
  REVIEW_PRINTED_MESSAGES: ReviewPrintedMessages,
  LEAVE_GUEST_NOTE: LeaveGuestNote,
  WEDDING_SHOP_ITEMS_MODAL: WeddingShopItemsModal,
  LETTERPRESS_LEARN_MORE: LetterpressLearnMore,
  SAMPLES_MODAL: SamplesModal,
  SINGLE_SAMPLE_LIMIT_SCREEN: SingleSampleLimitScreenModal,
  MULTI_SAMPLES_TUTORIAL: MultiSamplesTutorialModal,
  PROJECT_CLONE_MODAL: ProjectCloneModal,
  SELECT_BLANK_NOTES: SelectBlankNotes,
  FILTER_FOIL_MODAL: FilterFoilModal,
  FILTER_LETTERPRESS_MODAL: FilterLetterpressModal,
  FILTER_MOBILE_MENU: FilterMobileMenu,
  EXPEDITED_SHIPPING_MODAL: ExpeditedShippingModal,
  BLEED_MODAL: BleedModal,
  SIMPLE_SIGNUP_MODAL: SimpleSignUpModal,
  PROOF_INFO_MODAL: ProofInfoModal,
  PROOF_INCREASE_CONFIRM_MODAL: ProofIncreaseConfirmModal,
  PROOF_DECREASE_CONFIRM_MODAL: ProofDecreaseConfirmModal,
  DISCARD_TY_NOTES_MODAL: DiscardTyNotesModal,
  PLACE_CARD_ON_MOBILE_MODAL: PlaceCardOnMobileModal,
  FAVORITES_MODAL: FavoritesModal,
  PLACE_CARD_GUEST_LIST_IMPORT: PlaceCardGuestListModals.ImportModal,
  PLACE_CARD_GUEST_LIST_WARNING: PlaceCardGuestListModals.WarningModal,
  CREATE_SUPERLINK: CreateSuperlink,
  CREATE_WEDDING_WEBSITE: CreateWeddingWebsite,
  PUBLISH_WEDDING_WEBISTE: PublishWeddingWebsite,
  DSTD_FREE_SAMPLE_MODAL: DigitalSTDFreeSampleModal,
  DIGITAL_TIPS: DigitalTips,
  DIGITAL_MOREINFO: DigitalMoreInfo,
  DIGITAL_HOW_IT_WORKS: HowItWorks,
  DIGITAL_DOWNLOAD_IMAGE: DigitalDownloadImageModal,
  DIGITAL_MAX_PUBLISHED: MaxPublished,
  DIGITAL_DELETE_CONFIRMATION: DigitalDeleteConfirmationModal,
  DIGITAL_MOVE_TO_DRAFTS: DigitalMoveToDraftsModal,
  DIGITAL_EXPIRY_INFO: DigitalExpiryInfoModal,
  DIGITAL_EMAIL_TEMPLATE_CUSTOMIZATION: DigitalEmailTemplateCustomizationModal,
  MATCHING_ITEM_PREVIEW_MODAL: MatchingItemPreviewModal,
};

const CardsModalRoot = ({
  hideModalFn,
  updateModalOptionsFn,
  isVisible,
  modalOptions,
  modalProps,
  modalType,
  openModalFn,
}) => {
  const {
    bottomModalOnMobile,
    disableBackgroundClick = false,
    fullScreenOnMobile,
    hideClose = false,
    onBack,
    size = 'lg',
    showInDrawer = false,
    warnOnClose,
    preventClose,
    closeCallback,
    styleOverride,
    roundCorners,
  } = modalOptions || {};

  const modalRef = useRef();

  const [modalContext, setModalContext] = useState({});

  useEffect(() => {
    setModalContext(modalProps.initialModalContext || {});
  }, [modalType, modalProps.initialModalContext]);

  const onHideModal = useCallback(() => {
    if (preventClose) {
      return;
    }

    // eslint-disable-next-line no-alert
    if (warnOnClose && !window.confirm('Warning: You will lose your changes if you exit.')) {
      return;
    }

    // Optional callback with context and options passed since modalOptions no longer reacts to changes.
    if (closeCallback instanceof Function) {
      closeCallback({
        modalOptions,
        modalContext,
        setModalOptions: updateModalOptionsFn,
        setModalContext,
      });
    }

    // Default modal close behaviour
    if (hideModalFn instanceof Function) {
      hideModalFn();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    modalOptions,
    modalContext,
    updateModalOptionsFn,
    setModalContext,
    closeCallback,
    hideModalFn,
  ]);

  const onBackgroundClick = useCallback(
    e => {
      if (!disableBackgroundClick && e.target === e.currentTarget) onHideModal();
    },
    [disableBackgroundClick, onHideModal]
  );

  const onEscape = useCallback(
    ({ keyCode }) => {
      if (!disableBackgroundClick && keyCode === 27) onHideModal();
    },
    [disableBackgroundClick, onHideModal]
  );

  const reopenCurrentModal = useCallback(() => {
    openModalFn(modalType, modalProps, modalOptions);
  }, [openModalFn, modalType, modalProps, modalOptions]);

  useEffect(() => {
    if (isVisible) {
      const orig = document.body.className;
      document.body.className = `${orig} modal-open`.trim();
      document.addEventListener('keydown', onEscape);
    } else {
      document.body.className = document.body.className.replace(/ ?modal-open/g, '');
    }

    // Whenever isVisible or onEscape change, the old keydown listener will be destroyed.
    return () => {
      document.removeEventListener('keydown', onEscape);
    };
  }, [isVisible, onEscape]);

  // Whenever the modal type changes (i.e. when switching between 2 modals), scroll to the top.
  useEffect(() => {
    if (modalRef && modalType) {
      modalRef.current.scrollTo(0, 0);
    }
  }, [modalRef, modalType]);

  if (!isVisible) return null;

  const SpecificModal = MODALS[modalType].component || MODALS[modalType];
  const specificClassName = MODALS[modalType].className || null;
  const modalClasses = cx(
    `modal-${size}`,
    {
      'modal-dialog invitation-modal-dialog': !showInDrawer,
      [styles.modalTypeDrawer]: showInDrawer,
      [styles.bottomModalOnMobile]: bottomModalOnMobile,
      [styles.fullScreenOnMobile]: fullScreenOnMobile,
    },
    modalOptions.className,
    specificClassName
  );

  return (
    <div className={styles.cardModal}>
      <div
        ref={modalRef}
        tabIndex="-1"
        role="dialog"
        className="modal in"
        style={{ zIndex: 1050, display: 'block' }}
        onClick={onBackgroundClick}
      >
        <div style={(modalOptions.style, { ...styleOverride })} className={modalClasses}>
          <div
            className={cx('modal-content card-modal-content', {
              [styles.modalTopButtonPadding]: !!onBack,
              [styles.modalRoundCorners]: roundCorners,
            })}
            style={modalOptions.contentStyle}
          >
            {!hideClose && (
              <button
                type="button"
                className={cx('modal-close', styles.modalClose)}
                onClick={onHideModal}
              >
                <img alt="" src={iconX} />
              </button>
            )}
            {!!onBack && (
              <div className={cx(styles.modalBack)} onClick={onBack}>
                <i className="zolaicon zolaicon-chevron-left" />
                <span>Back</span>
              </div>
            )}
            <SpecificModal
              {...modalProps}
              modalContext={modalContext}
              setModalContext={newContext => setModalContext({ ...modalContext, ...newContext })}
              hideModalFn={onHideModal}
              setModalOptions={updateModalOptionsFn}
              reopenCurrentModal={reopenCurrentModal}
            />
          </div>
        </div>
      </div>
      <div className="modal-backdrop in" />
    </div>
  );
};

CardsModalRoot.propTypes = {
  modalType: PropTypes.string,
  modalProps: PropTypes.shape({
    callback: PropTypes.func,
  }),
  hideModalFn: PropTypes.func,
  isVisible: PropTypes.bool,
  modalOptions: PropTypes.shape({}),
  openModalFn: PropTypes.func,
  updateModalOptionsFn: PropTypes.func,
};

const mapStateToProps = state => state.cards.modal;

const mapDispatchToProps = {
  hideModalFn: hideModal,
  openModalFn: openModal,
  updateModalOptionsFn: updateModalOptions,
};

export default connect(mapStateToProps, mapDispatchToProps)(CardsModalRoot);
